import { motion } from "framer-motion";
import { HERO_AFTER, HERO_BEFORE } from "../lib/constants";

/**
 * Hero "Transformation Reveal":
 * Mounts a grayscale + blurred "before" image stacked on top of a sharp "after" image,
 * then fades the before layer out smoothly over ~1.4 seconds.
 */
export default function HeroReveal() {
    return (
        <div
            data-testid="hero-reveal"
            className="absolute inset-0 overflow-hidden"
        >
            {/* After (sharp, polished) sits underneath */}
            <img
                src={HERO_AFTER}
                alt="Finished renovation"
                className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Before (muted/blurred) fades away */}
            <motion.img
                src={HERO_BEFORE}
                alt="Before renovation"
                initial={{ opacity: 1, filter: "grayscale(100%) blur(6px)" }}
                animate={{
                    opacity: 0,
                    filter: "grayscale(0%) blur(0px)",
                }}
                transition={{
                    duration: 1.4,
                    ease: [0.22, 1, 0.36, 1],
                    delay: 0.15,
                }}
                className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Diagonal sweep highlight */}
            <motion.div
                initial={{ x: "-110%" }}
                animate={{ x: "110%" }}
                transition={{ duration: 1.4, ease: "easeInOut", delay: 0.05 }}
                className="absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-[-12deg] pointer-events-none"
            />

            {/* Dark overlay for legibility */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/85" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-transparent" />
        </div>
    );
}
